
import { defineComponent, getCurrentInstance, ref, computed, watch, onMounted, PropType } from 'vue';

import { useLogin } from '@/hooks/useLogin';
import useSetPageTitle from '../useSetPageTitle';

import Loading from '@/components/loading/index.vue';
import LoginPopup from '@/components/login/index.vue';

import { immediateSendLog } from '@/common/radar';
import { commonPvParams } from '@/common/utils';
import { checkIfAiChatApp } from '@/common/app';
import { PwaBridge } from '@/common/bridge';

export enum AI_SETTING_PAGE_NAME_ENUM {
    AIFRIENDS_SETTING = 'AIFRIENDS_SETTING', // 设置页
    AIFRIENDS_FEEDBACK = 'AIFRIENDS_FEEDBACK', // 反馈页
    AIFRIENDS_ACCOUNT = 'AIFRIENDS_ACCOUNT', // 账户页
    AIFRIENDS_ACCOUNT_DELETE = 'AIFRIENDS_ACCOUNT_DELETE', // 删除账户页
    AIFRIENDS_ABOUT_US = 'AIFRIENDS_ABOUT_US', // 介绍页
    AIFRIENDS_AGREEMENT = 'AIFRIENDS_AGREEMENT', // 协议页
    AIFRIENDS_VOICE_CALL_PERMISSION = 'PERMISSION_SETTING', // 语音通话权限页
}

const PAGE_TITLE_MAP = {
    [AI_SETTING_PAGE_NAME_ENUM.AIFRIENDS_SETTING]: 'setting_page',
    [AI_SETTING_PAGE_NAME_ENUM.AIFRIENDS_FEEDBACK]: 'feedback',
    [AI_SETTING_PAGE_NAME_ENUM.AIFRIENDS_ACCOUNT]: 'account',
    [AI_SETTING_PAGE_NAME_ENUM.AIFRIENDS_ACCOUNT_DELETE]: 'delete_account',
    [AI_SETTING_PAGE_NAME_ENUM.AIFRIENDS_ABOUT_US]: 'about_us',
    [AI_SETTING_PAGE_NAME_ENUM.AIFRIENDS_AGREEMENT]: 'terms_policies',
    [AI_SETTING_PAGE_NAME_ENUM.AIFRIENDS_VOICE_CALL_PERMISSION]: 'privacy_permissions',
};

const SkipLoginPageName = [AI_SETTING_PAGE_NAME_ENUM.AIFRIENDS_FEEDBACK];

export default defineComponent({
    components: {
        LoginPopup,
        Loading,
    },
    props: {
        pageName: {
            type: String as PropType<AI_SETTING_PAGE_NAME_ENUM>,
            default: '',
        },
        pvParams: {
            type: Object as PropType<Record<string, any>>,
            default: () => {},
        },
    },
    setup(props) {
        const { proxy } = getCurrentInstance() || {};
        const visible = ref(false);
        const isApp = ref(checkIfAiChatApp());
        const appLoginSuccess = ref(false);
        useSetPageTitle(PAGE_TITLE_MAP[props.pageName]);

        const { showLoginPopup, handleLoginPopupClose, changeLoginStatus, changeLoginPopupShow } = useLogin();

        const needAutoShowLoginPopup = computed(() => {
            return (
                !isApp.value &&
                proxy?.$store?.state?.userModule?.hasQueriedUserInfo &&
                proxy?.$store?.state?.userModule?.userInfo === undefined &&
                !SkipLoginPageName.includes(props.pageName)
            );
        });

        async function appLogin() {
            try {
                await PwaBridge.appLogin();
                appLoginSuccess.value = true;
            } catch (err) {
                appLoginSuccess.value = false;
            }
        }

        onMounted(() => {
            const params = commonPvParams({ defaultPageSource: props.pageName });
            immediateSendLog({
                type: 'pv',
                name: props.pageName,
                value: {
                    ...params,
                    ...props.pvParams,
                },
            });
        });

        onMounted(async () => {
            if (isApp.value && !SkipLoginPageName.includes(props.pageName)) {
                await appLogin();
            }
        });

        watch(
            needAutoShowLoginPopup,
            val => {
                if (val) {
                    visible.value = true;
                    // changeLoginPopupShow(true);
                }
            },
            {
                immediate: true,
            }
        );

        async function clickHandlerProxy(e: Event) {
            if (SkipLoginPageName.includes(props.pageName)) {
                return;
            }
            if (needAutoShowLoginPopup.value && !isApp.value) {
                e.stopPropagation();
                visible.value = true;
            } else if (isApp.value && !appLoginSuccess.value) {
                e.stopPropagation();
                await appLogin();
            }
        }

        function onClose() {
            // changeLoginPopupShow(false);
            visible.value = false;
        }

        return {
            visible,
            showLoginPopup,
            changeLoginStatus,
            handleLoginPopupClose,
            clickHandlerProxy,
            onClose,
            isApp,
            SkipLoginPageName,
        };
    },
});
